export default __webpack_public_path__ + "static/media/fail-sync-small.d59467a9.svg";